import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { OfferTypeService } from '../services/offer-types.service';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { CHttp } from '../../core/services/chttp.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs';
import { BaseEditComponent } from '../../core/common/base-component';
import { Title } from '@angular/platform-browser';

import { RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers } from '@angular/http';
import { config } from '../../app.config';

@Component({
  selector: 'ch-offer-type-edit',
  templateUrl: './offer-type-edit.component.html',
  styleUrls: ['./offer-type-edit.component.css'],
})
export class OfferTypeEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  public offerTypeId: string;
  public offerTypeData: any = {};
  public offerName: string;
  public editMode: boolean;

  public errors = {};
  /**
   * Default server error error message.
   */
  public error: any;

  @ViewChild('fileInput') fileInput;

  constructor(
    private offerTypeService: OfferTypeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.editMode = this.routeHelperService.isCurrentPageEdit();
        this.offerTypeId = params.id;

        if (this.editMode) {
          this.fetchData(this.offerTypeId);
        } else {
          this.titleService.setTitle(`New Offer Type | CODE Hospitality CMS`);
        }
      });
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private fetchData(id: string) {
    this.loading = true;
    this.offerTypeService.getOfferType(this.offerTypeId).subscribe(
      data => {
        this.offerTypeData = data.json();
        this.offerName = this.offerTypeData.name;
        this.titleService.setTitle(`${this.offerName} | Offer Types | CODE Hospitality CMS`);
      },
      error => {},
      () => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  public edit(form) {
    if (!form.valid) {
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }

      return;
    }

    this.loading = true;
    const methodToCall = this.editMode ? 'updateOfferType' : 'addOfferType';

    this.offerTypeService[methodToCall](this.offerTypeData).subscribe(
      resp => {
        this.cancel();
      },
      error => {
        this.loading = false;
        if (error.error) {
          this.error = 'Error submitting the form';

          return;
        }
        for (const item of error.errors instanceof Array ? error.errors : []) {
          if (!form.controls[item.field]) {
            continue;
          }

          form.controls[item.field].setErrors({ [item.field]: item.message });
          this.errors[item.field] = item.message;
        }
      },
      () => {
        this.loading = false;
      }
    );
  }

  public cancel() {
    this.router.navigateByUrl('/admin/offer-types');
  }

  public delete() {
    if (!confirm('Are you sure you want to delete offer type?')) {
      return;
    }

    this.offerTypeService.deleteOfferType(this.offerTypeId).subscribe(resp => {
      this.cancel();
    });
  }

  public homeIconChanged(data) {
    this.offerTypeData.homeIconId = data;
  }

  public homeIconSelectedChanged(data) {
    this.offerTypeData.homeIconSelectedId = data;
  }

  public searchIconChanged(data) {
    this.offerTypeData.searchIconId = data;
  }

  public searchIconSelectedChanged(data) {
    this.offerTypeData.searchIconSelectedId = data;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offer-types/offer-type-edit/offer-type-edit.component.ts